import type React from 'react'

import { getRouteUrl, isAdmin, replaceCompanyIdInPath } from '@helpers'

import { ListItem } from '@components/ui'
import { SettingsIcon } from '@components/ui/svgIcons'
import { CompanyRole } from '@oldComponents/CompanyRole'
import { OverflowTextWithTooltip } from '@oldComponents/OverflowTextWithTooltip'

import { RouteKeys, ROUTES } from '@constants'

import { TertiaryInfoTypography } from '../styles'
import { CompanySelectLink, CompanySettingsLink } from './styles'

interface MenuItemWithNavigationProps {
  company: CompaniesItem
  disabled: boolean
  isHighlighted: boolean
  onSelect: (company: CompaniesItem, isSettings?: boolean) => React.MouseEventHandler<HTMLAnchorElement>
}

export function MenuItemWithNavigation({ company, disabled, onSelect, isHighlighted }: MenuItemWithNavigationProps) {
  return (
    <ListItem selected={isHighlighted} disabled={disabled} menuItem>
      <CompanySelectLink
        onClick={onSelect(company)}
        to={replaceCompanyIdInPath(`${ROUTES.root}/:company_id/`, company.id)}
      >
        <OverflowTextWithTooltip withPortal>{company.name}</OverflowTextWithTooltip>
        <TertiaryInfoTypography>
          <CompanyRole data={company} />
        </TertiaryInfoTypography>
      </CompanySelectLink>
      {isAdmin(company.role) && (
        <CompanySettingsLink
          data-testid="company-settings-btn"
          onClick={onSelect(company, true)}
          to={getRouteUrl(RouteKeys.COMPANY, company.id)}
        >
          <SettingsIcon />
        </CompanySettingsLink>
      )}
    </ListItem>
  )
}
